import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar el estado de conexión a internet
 * Monitorea los eventos online/offline del navegador y actualiza el estado
 * @returns {boolean} true si está online, false si está offline
 */
export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };
    
    const handleOffline = () => {
      setIsOnline(false);
    };

    // Agregar event listeners para detectar cambios de conexión
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup function para remover los event listeners
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
};
